import { useTranslation } from 'react-i18next';

import type { useCopilotRequestSettings } from 'app/modules/wallforming/components/copilot/hooks/useCopilotRequestSettings';

interface CopilotRequestSettingsProps {
    settings: ReturnType<typeof useCopilotRequestSettings>;
    disabled: boolean;
    showTimeout?: boolean;
}

const inputClassName =
    'h-8 w-full min-w-0 rounded-sm border border-border-light bg-background-default px-2 text-xs text-text-default';

export const CopilotRequestSettings = ({ settings, disabled, showTimeout = true }: CopilotRequestSettingsProps) => {
    const { t } = useTranslation();

    return (
        <div className="space-y-1">
            <div className="flex flex-wrap gap-2">
                <label className="min-w-0 flex-1 text-xs text-text-light">
                    {t('copilotModel')}
                    <select
                        aria-label={t('copilotModel')}
                        className={inputClassName}
                        disabled={disabled || !settings.defaultModel || settings.modelError}
                        value={settings.model}
                        onChange={(event) => settings.setModel(event.target.value)}
                    >
                        <option value="">
                            {settings.defaultModel
                                ? t('copilotDefaultModel', { model: settings.defaultModel })
                                : t('copilotModelUnavailable')}
                        </option>
                        {settings.models.map((model) => (
                            <option key={model} value={model}>
                                {model}
                            </option>
                        ))}
                    </select>
                </label>
                {showTimeout && (
                    <label className="w-32 text-xs text-text-light">
                        {t('copilotTimeout')}
                        <input
                            aria-invalid={!settings.isTimeoutValid}
                            aria-label={t('copilotTimeout')}
                            className={inputClassName}
                            disabled={disabled}
                            max={1800}
                            min={30}
                            step={1}
                            type="number"
                            value={settings.timeout}
                            onChange={(event) => settings.setTimeout(event.target.value)}
                        />
                    </label>
                )}
            </div>
            {settings.modelError && (
                <div className="text-xs text-text-danger" role="alert">
                    {t('copilotModelUnavailable')}
                </div>
            )}
            {settings.modelWasRemoved && (
                <div className="text-xs text-text-light" role="status">
                    {t('copilotModelRemoved')}
                </div>
            )}
            {showTimeout && !settings.isTimeoutValid && (
                <div className="text-xs text-text-danger" role="alert">
                    {t('copilotTimeoutRange')}
                </div>
            )}
        </div>
    );
};
